import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { CapabilitySpecService } from '../capability-spec.service'

@Directive({
  selector: '[appCapabilitySpecSelect]',
})
export class CapabilitySpecSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  @Input()
  public excludeIds: string[] = []
  private select = inject(ElderSelectComponent)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const capabilitySpecService = inject(CapabilitySpecService)
    this.select.displayProperty = 'name'
    this.select.placeholder = 'capabilities.capabilities'
    this.select.isOptionDisabledFn = (cs) => this.excludeIds.includes(cs.id)
    this.select.dataSource = capabilitySpecService
    this.select.sorts = [new Sort('id', 'asc')]
  }

  public clear(): void {
    this.select.clear(null)
  }
}
